var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C3.44772 3 3 3.44772 3 4V8C3 8.55228 3.44772 9 4 9V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V9C20.5523 9 21 8.55228 21 8V4C21 3.44772 20.5523 3 20 3H4ZM18 9H6V19H18V9ZM5 7V5H19V7H5Z",
    fill: "#040405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11L15 11C15.5523 11 16 11.4477 16 12Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDNDMy40NDc3MiAzIDMgMy40NDc3MiAzIDRWOEMzIDguNTUyMjggMy40NDc3MiA5IDQgOVYyMEM0IDIwLjU1MjMgNC40NDc3MiAyMSA1IDIxSDE5QzE5LjU1MjMgMjEgMjAgMjAuNTUyMyAyMCAyMFY5QzIwLjU1MjMgOSAyMSA4LjU1MjI4IDIxIDhWNEMyMSAzLjQ0NzcyIDIwLjU1MjMgMyAyMCAzSDRaTTE4IDlINlYxOUgxOFY5Wk01IDdWNUgxOVY3SDVaIiBmaWxsPSIjMDQwNDA1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgMTJDMTYgMTIuNTUyMyAxNS41NTIzIDEzIDE1IDEzSDlDOC40NDc3MiAxMyA4IDEyLjU1MjMgOCAxMkM4IDExLjQ0NzcgOC40NDc3MiAxMSA5IDExTDE1IDExQzE1LjU1MjMgMTEgMTYgMTEuNDQ3NyAxNiAxMloiIGZpbGw9IiMwNDA0MDUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };